import { createContext, useContext } from 'react';
import { UserService } from 'src/app/project/modules/user/user.service';

export interface AngularServices {
  userService?: UserService;
}

export const AngularBridgeContext = createContext<AngularServices>({});

export const useAngularService = () => useContext(AngularBridgeContext);
